import type { AuthError } from "@azure/msal-browser-1p";
import { getHttpStatusFromError } from "./utils/getHttpStatusFromError";
export type AuthStatus = "None" | "MsalAuthSuccess" | "MsalAuthError";

let authStatus: AuthStatus = "None";
let authError: string = "";
let authHttpStatus: number | undefined;
let fromCache: boolean | undefined;
let pageVisible: boolean | undefined;
let msalVersion: string = "";
let authErrorDetails: {
    errorMessage: string;
    subError: string;
    correlationId: string;
} | undefined;

export function setAuthStatusInfo(msalAuthStatus: AuthStatus, correlationId: string, version: string, error?: AuthError, cache?: boolean, pageAlwaysVisible?: boolean): void {
    authStatus = msalAuthStatus;
    fromCache = cache;
    pageVisible = pageAlwaysVisible;
    msalVersion = version;
    if (error) {
        authError = error.errorCode;
        authHttpStatus = getHttpStatusFromError(error);
        authErrorDetails = {
            errorMessage: error.errorMessage,
            subError: error.subError,
            correlationId,
        };
    }
    else {
        authError = "";
        authHttpStatus = undefined;
        authErrorDetails = undefined;
    }
}

export interface AuthStatusInfo {
    authStatus: AuthStatus;
    authError: string;
    httpStatus: number | undefined;
    fromCache: boolean | undefined;
    pageVisible: boolean | undefined;
    msalVersion: string;
    authErrorDetails?: {
        errorMessage: string;
        subError: string;
        correlationId: string;
    };
}

export function getAuthStatusInfo(): AuthStatusInfo {
    return {
        authStatus,
        authError,
        httpStatus: authHttpStatus,
        fromCache,
        pageVisible,
        msalVersion,
        authErrorDetails,
    };
}
